import { dropinApi, httpClient } from "@bw/shared/api";
import type { Schema } from "@bw/shared/types/generated";

export type StaffWalkInPartyRequest = Schema["StaffWalkInPartyRequest"];

export async function searchActiveWalkInCustomers(
  facilityId: string,
  query: string,
  limit: number,
  cursor?: string,
): Promise<{
  items: Schema["FacilityPlayerSearchResult"][];
  nextCursor: string | null;
}> {
  const page = await dropinApi.listActiveSessions(facilityId, {
    q: query.trim(),
    limit,
    ...(cursor ? { cursor } : {}),
  });
  return {
    items: (page.items ?? []).map((session) => ({
      user_id: session.user_id,
      display_name: session.display_name,
      avatar_url: null,
      association: "checkin",
    })),
    nextCursor: page.next_cursor ?? null,
  };
}

export function addWalkInParty(
  request: StaffWalkInPartyRequest,
): Promise<Schema["QueueEntryResponse"]> {
  return httpClient.post<Schema["QueueEntryResponse"]>(
    "/queue/walk-in-party",
    request,
  );
}
